import Utility from '../util/Utility';

const TTTimelineContainer = ({ trophyInfo }) => {
  const timelineData = trophyInfo.timeline;

  const TimelineMileageAndValue = ({ eventItem }) => {
    const mileage = eventItem.eventMileage;
    const value = eventItem.eventValue;
    //console.log(mileage, value);

    if (mileage > -1 && value > -1) {
      return (
        <div>
          <div>
            <i className="fa-solid fa-car me-2 text-secondary" />
            {Utility.numWithCommas(mileage)} miles
          </div>
          <div>
            <i className="fa-solid fa-coins me-2 text-secondary" />£
            {Utility.numWithCommas(value.toFixed(2))}
          </div>
        </div>
      );
    } else if (mileage > -1) {
      return (
        <span>
          <i className="fa-solid fa-car me-2 text-secondary" />
          {Utility.numWithCommas(mileage)} miles
        </span>
      );
    } else if (value > -1) {
      return (
        <span>
          <i className="fa-solid fa-coins me-2 text-muted" />£
          {Utility.numWithCommas(value.toFixed(2))}
        </span>
      );
    }

    return null;
  };

  return (
    <>
      <h3 className="tt-heading text-warning">Timeline</h3>
      <div className="mb-5">
        {!timelineData && <div className="text-muted">(No data available)</div>}

        {timelineData && (
          <>
            <div className="mb-1">
              Please note that accuracy cannot be guaranteed and this is
              intended as a guide only.
            </div>

            <div className="mb-3">
              <div className="text-muted mb-4">
                (
                {Utility.getPluralisedYIESWithValueIfNeeded(
                  'entr',
                  timelineData.length,
                )}
                )
              </div>

              {timelineData.map((eventItem, eventIdx) => {
                return (
                  <div
                    className="card bg-dark border-secondary shadow mt-4 position-relative"
                    key={eventIdx}
                  >
                    <div className="tt-timeline-icon-event-type center-gentle-flex">
                      <i
                        className={Utility.getIconForEventType(eventItem).icon}
                      />
                    </div>
                    <div className="card-body">
                      <div>
                        <strong>
                          <span className="text-warning">
                            {new Date(eventItem.eventDate).toLocaleDateString(
                              undefined,
                              {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                              },
                            )}
                          </span>
                          <span className="text-muted mx-1">-</span>
                          <span className="text-info">
                            {eventItem.eventTypeDescription}
                          </span>
                        </strong>
                      </div>
                      {(eventItem.eventMileage > -1 ||
                        eventItem.eventValue > -1) && (
                        <div className="text-light mt-2">
                          <TimelineMileageAndValue eventItem={eventItem} />
                        </div>
                      )}
                      {eventItem.eventDescription !== null && (
                        <div className="mt-2">{eventItem.eventDescription}</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TTTimelineContainer;
